var map = {
  "./cs.messages.tsx": [
    "5350",
    [
      8981
    ]
  ],
  "./en.messages.tsx": [
    "51583",
    [
      1294
    ]
  ],
  "./sl.messages.tsx": [
    "72263",
    [
      7966
    ]
  ],
  "./hu.messages.tsx": [
    "19515",
    [
      4602
    ]
  ],
  "./de.messages.tsx": [
    "57335",
    [
      3702
    ]
  ],
  "./it.messages.tsx": [
    "76201",
    [
      3468
    ]
  ],
  "./pl.messages.tsx": [
    "92752",
    [
      3499
    ]
  ],
  "./fr.messages.tsx": [
    "61240",
    [
      1811
    ]
  ],
  "./sk.messages.tsx": [
    "89710",
    [
      6077
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 28544;
module.exports = __rspack_async_context;
